import axios from 'axios';
import { BASE_URL } from './apiconfig';

export const getMyNotifications = async (token: string | null, params: string) => {
  try {
    const { data } = await axios.get(`${BASE_URL}/notifications/my?${params}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data;
  } catch (error) {
    console.log("Failed to fetch my notifications. ", error);
    throw error;
  }
}

export const getNotifications = async (token: string | null, params: string) => {
  try {
    const { data } = await axios.get(`${BASE_URL}/notifications?${params}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data;
  } catch (error) {
    console.log("Failed to fetch notifications. ", error);
    throw error;
  }
}

export const getNotificationById = async (token: string | null, id: number) => {
  try {
    const { data } = await axios.get(`${BASE_URL}/notifications/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data;
  } catch (error) {
    console.log("Failed to fetch notification. ", error);
    throw error;
  }
}

export const createNotificationApi = async (token: string | null, notifInfo: {
  title: string,
  text: string,
  image_key?: string | null,
  scheduled_at?: string | null,
  action?: any,
  url?: string | null,
  platform?: string[] | null,
  dealer_ids?: number[],
  user_ids?: number[] | null,
}) => {
  try {
    const response = await axios.post(`${BASE_URL}/notifications`, notifInfo, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
  } catch (error) {
    console.log("Failed to create notification. ", error);
    throw error;
  }
}

export const updateNotificationApi = async (token: string | null, id: number, notifInfo: any) => {
  try {
    const { data } = await axios.put(`${BASE_URL}/notifications/${id}`, notifInfo, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data;
  } catch (error) {
    console.log("Failed to update notification. ", error);
    throw error;
  }
}

export const deleteNotificationApi = async (token: string | null, id: number) => {
  try {
    const { data } = await axios.delete(`${BASE_URL}/notifications/${id}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data;
  } catch (error) {
    console.log("Failed to delete notification. ", error);
    throw error;
  }
}

export const markNotificationReadApi = async (token: string | null, id: number) => {
  try {
    const { data } = await axios.put(`${BASE_URL}/notifications/${id}/read`, {}, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return data;
  } catch (error) {
    console.log("Failed to mark notification as read. ", error);
    throw error;
  }
}
